module.exports = __webpack_public_path__ + "assets/img/upload-logo-en.39860840.png";